module.exports = __webpack_public_path__ + "static/img/lunbo2.4373f0b2.png";